














import {defineComponent, computed} from '@vue/composition-api';
import {useGetters} from 'vuex-composition-helpers';
import {sortAppByTitle} from "@/apps/FavoriteAppsWidget/utils/sort";
import AppComponent from './App.vue';
import MessageComponent from '@/shared/components/Message.vue';
import ErrorMessagesComponent from '@/shared/components/ErrorMessages.vue';

export default defineComponent({
    name: 'AppListComponent',
    components: {
        MessageComponent,
        ErrorMessagesComponent,
        AppComponent
    },
    setup() {
        const {getConfig, getError, getLoading, getFavoriteApps} = useGetters([
            'getConfig',
            'getError',
            'getLoading',
            'getFavoriteApps'
        ]);

        const favoriteAppsOrdered = computed(() => {
            return sortAppByTitle(getFavoriteApps.value);
        });

        return {
            getConfig,
            getError,
            getLoading,
            getFavoriteApps,
            favoriteAppsOrdered
        };
    }
});
